import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Utils } from '@app/_helpers';
import { BILLING_PORTAL_ERROR, ConfigurationService, NgxToastrService } from '@app/_shared';
import { BILLING_PORTAL_ROUTES, CREDITS_EXHAUSTED_DIALOG_CONFIG } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.constants';
import { CreditsExhaustedDialogItem } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.interface';
import { MbPlansService } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.service';
import { PlanSubscription } from '@app/modules/trading/modules/profile/components/plans/plans.enums';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-credits-exhausted-popup',
  templateUrl: './credits-exhausted-popup.component.html',
  styleUrls: ['./credits-exhausted-popup.component.scss']
})
export class CreditsExhaustedPopupComponent {

  billingRoutes = BILLING_PORTAL_ROUTES;

  /** Set while a billing redirect is in flight; both buttons stay disabled. */
  pendingTarget: BILLING_PORTAL_ROUTES | null = null;

  plansEnabled: boolean = false;

  dialogConfig: CreditsExhaustedDialogItem = CREDITS_EXHAUSTED_DIALOG_CONFIG.ACTIVE;

  constructor(
    private dialogRef: MatDialogRef<CreditsExhaustedPopupComponent>,
    private mbPlansService: MbPlansService,
    private toastr: NgxToastrService,
    private configService: ConfigurationService,
  ) { }

  ngOnInit(): void {
    this.plansEnabled = this.configService.remoteConfigCacheObj?.PLANS_ENABLED;
    const dialogConfigs = this.configService.remoteConfigCacheObj?.CREDITS_EXHAUSTED_DIALOG_CONFIG ?? CREDITS_EXHAUSTED_DIALOG_CONFIG;
    this.mbPlansService.getCurrentPlan().subscribe(res => {
      this.dialogConfig = dialogConfigs[res.subscription_status as PlanSubscription || PlanSubscription.ACTIVE];
    });
  }

  get isBillingPortalBusy(): boolean {
    return this.pendingTarget !== null;
  }

  openBillingPortal(target: BILLING_PORTAL_ROUTES): void {
    if (this.isBillingPortalBusy) {
      return;
    }
    this.pendingTarget = target;
    this.mbPlansService.getSignedRedirectUrl(target).pipe(
      finalize(() => { this.pendingTarget = null; })
    ).subscribe({
      next: (res) => {
        if (res.success && res.data?.signed_url) {
          Utils.navigateToUrl(res.data.signed_url);
          this.dialogRef.close();
        } else {
          this.toastr.simpleCustomToaster(BILLING_PORTAL_ERROR, false);
          this.dialogRef.close();
        }
      }
    });
  }

}
